import React from 'react';
import { Link } from 'gatsby';
import Layout from '../components/Layout';
import Section from '../components/Section';
import { Container, Row, Column } from '../components/Grid';
import Image from '../components/Image';
import Icon from '../components/Icon';
import OutboundLink from '../components/OutboundLink';

const IndexPage = ({ data }) => (
  <Layout title="About the Program">
    <Section className="about-mission">
      <Container>
        <Row>
          <Column size={11}>
            <h2>Inspiring Educators to Engage in Wellness</h2>
            <p>
              Together with Alliance for a Healthier Generation and Discovery
              Education, Kaiser Permanente is expanding its Resilience in School
              Environments (RISE) initiative to offer a versatile series of
              no-cost virtual and onsite resources designed to foster greater
              social and emotional resiliency in schools.
            </p>
          </Column>
        </Row>
        <Row verticalAlignBottom>
          <Column size={5} className="about-mission__img">
            <Image filename="about-mission.png" />
          </Column>
          <Column size={7} className="about-mission__content">
            <h3>Mission Statement</h3>
            <p>
              Building a community of advocates by inspiring educators and
              administrators to incorporate trauma-informed educational methods
              in schools nationwide.
            </p>
            <h3>For Educators</h3>
            <p>
              Help enhance your performance as an educator and improve student
              outcomes with the no-cost social-emotional learning resources
              available from <strong>Ready, Set, RISE!</strong>
            </p>
            <p>
              <Link to="/learning-modules" className="text-bold">
                Explore the e-learning modules{' '}
                <Icon name="caratright" marginLeft />
              </Link>
            </p>
          </Column>
        </Row>
      </Container>
    </Section>
    <Section className="about-partners">
      <Container>
        <h2>Supporting Partners</h2>
        <Row className="about-partner">
          <Column size={3}>
            <Image
              filename="kaiser-logo.svg"
              className="about-partner-logo about-partner-logo--kaiser"
              alt="Kaiser Permanente"
            />
          </Column>
          <Column size={9}>
            <h3>Kaiser Permanente</h3>
            <p>
              Providing high-quality, affordable health care services and
              improving the health of members and their communities over 70
              years. Kaiser Permanente is deeply invested in building healthier
              communities by improving conditions of health and equity for all.
            </p>
            <OutboundLink
              to="https://healthy.kaiserpermanente.org/"
              className="text-bold"
            >
              <Icon name="externallink" marginRight />
              Learn more
            </OutboundLink>
          </Column>
        </Row>
        <Row className="about-partner">
          <Column size={3}>
            <Image
              filename="healthier-gen-logo.svg"
              className="about-partner-logo about-partner-logo--healthier-gen"
              alt="Alliance for a Healthier Generation"
            />
          </Column>
          <Column size={9}>
            <h3>Alliance for a Healthier Generation</h3>
            <p>
              The Alliance for a Healthier Generation reached more than 29
              million children — empowering kids to develop lifelong healthy
              habits by ensuring the environments that surround them provide and
              promote good health.
            </p>
            <OutboundLink
              to="https://www.healthiergeneration.org/"
              className="text-bold"
            >
              <Icon name="externallink" marginRight />
              Learn more
            </OutboundLink>
          </Column>
        </Row>
        <Row className="about-partner">
          <Column size={3}>
            <Image
              filename="hearts-logo.png"
              className="about-partner-logo about-partner-logo--hearts"
              alt="HEARTS"
            />
          </Column>
          <Column size={9}>
            <h3>HEARTS</h3>
            <p>
              University of California San Francisco HEARTS is an
              awarding-winning program that aims to promote school success for
              trauma-impacted children and youth by creating more
              trauma-informed, safe, supportive, engaging, and equitable
              learning and teaching environments that foster resilience and
              wellness for everyone in the school community, students and adults
              alike. Equity and social justice through cultural humility and
              responsiveness are central to our approach.
            </p>
            <OutboundLink to="https://hearts.ucsf.edu" className="text-bold">
              <Icon name="externallink" marginRight />
              Learn more
            </OutboundLink>
          </Column>
        </Row>
        <Row className="about-partner">
          <Column size={3}>
            <Image
              filename="de-logo-positive.png"
              className="about-partner-logo about-partner-logo--de"
              alt="Discovery Education"
            />
          </Column>
          <Column size={9}>
            <h3>Discovery Education</h3>
            <p>
              Discovery Education is the global leader in standards-aligned
              digital curriculum resources, engaging content, and professional
              learning for K-12 classrooms, through award-winning digital
              textbooks, multimedia resources, and the largest professional
              learning network of its kind.
            </p>
            <OutboundLink
              to="https://www.discoveryeducation.com"
              className="text-bold"
            >
              <Icon name="externallink" marginRight />
              Learn more
            </OutboundLink>
          </Column>
        </Row>
      </Container>
    </Section>
    <Section>
      <Container>
        <div className="about-additional-resources">
          <Row>
            <Column size={6}>
              <div className="about-additional-resources__content">
                <h2 className="about-additional-resources__heading">
                  Additional RISE Resources
                </h2>
                <p>
                  The RISE Index and Healthier Generation Action Center provides
                  tools, guidance, and training to help create healthier
                  environments that empower kids to thrive. Access an assessment
                  tool to gauge how well schools and districts are addressing
                  social and emotional health.
                </p>
                <OutboundLink
                  to="https://www.healthiergeneration.org/app/account/login"
                  className="text-bold"
                >
                  <Icon name="externallink" marginRight />
                  Learn more
                </OutboundLink>
              </div>
            </Column>
            <Column size={6}>
              <Image filename="about-additional-resources.jpg" />
            </Column>
          </Row>
        </div>
      </Container>
    </Section>
  </Layout>
);

export default IndexPage;
